import _ from 'lodash'

export default {
  handleApiError,
  handleApiException,
  handlePaymentError,
  handleStreamingError,
  handleCommunicationError,
  getStatusCodeErrorMessage
}

export const ErrorCodes = {
  NOT_REGISTERED_USER: 1002,
  TOKEN_EXPIRED: 1003
}

function getStatusCodeErrorMessage (status) {
  if (status === 401) {
    return 'You are not authorized to access this resource'
  } else if (status === 403) {
    return 'You are not allowed to access this resource'
  } else if (status === 404) {
    return 'Resource not found'
  } else {
    return 'Oops, Something went wrong!'
  }
}

function handleApiError (
  error,
  options = {
    showAuthenticationError: false
  }
) {
  const { error_code, error: message } = error
  let result = { code: error_code, message, notify: true }
  if (!options.showAuthenticationError) {
    result = {
      ...result,
      notify: !(error_code === ErrorCodes.NOT_REGISTERED_USER || error_code === ErrorCodes.TOKEN_EXPIRED)
    }
  }
  return result
}

function handleApiException (
  error,
  options = {
    showAuthenticationError: false
  }
) {
  let message = error.message
  if (error?.response?.status) {
    message = getStatusCodeErrorMessage(error?.response?.status)
  }

  let result = { message, notify: true }
  if (!options.showAuthenticationError) {
    result = {
      ...result,
      notify: error?.response?.status !== 401
    }
  }
  return result
}

function handlePaymentError (
  error,
  options = {
    showAuthenticationError: false
  }
) {
  const { data, status } = error;
  let message = getStatusCodeErrorMessage(status);
  if (data.errors) {
    if (_.isArray(data.errors)) {
      message = data.errors
        .map((err) => (_.isObject(err) ? err.message : err))
        .join(",");
    } else {
      message = _.isObject(data.errors) ? data.errors.message : data.errors;
    }
  } else {
    if (data?.error?.message) message = data.error.message;
  }

  let result = { message, notify: true }
  if (!options.showAuthenticationError) {
    result = {
      ...result,
      notify: error?.status !== 401
    }
  }
  return result
}

function handleStreamingError (
  error,
  options = {
    showAuthenticationError: false
  }
) {
  const { data, status } = error;
  let message = getStatusCodeErrorMessage(status);
  if (data.errors) {
    if (_.isArray(data.errors)) {
      message = data.errors
        .map((err) => (_.isObject(err) ? err.message : err))
        .join(",");
    } else {
      message = _.isObject(data.errors) ? data.errors.message : data.errors;
    }
  } else {
    if (data?.error?.message) message = data.error.message;
  }

  let result = { message, notify: true }
  if (!options.showAuthenticationError) {
    result = {
      ...result,
      notify: error?.status !== 401
    }
  }
  return result
}

function handleCommunicationError (
  error,
  options = {
    showAuthenticationError: false
  }
) {
  const { data, status } = error;
  let message = getStatusCodeErrorMessage(status);
  if (_.isArray(data.error)) {
    message = _.isObject(data.error[0]) ? data.error[0].message : data.error[0]
  }

  let result = { message, notify: true }
  if (!options.showAuthenticationError) {
    result = {
      ...result,
      notify: error?.status !== 401
    }
  }
  return result
}
